/**
 * Utilitaires de gestion des plages temporelles (incluant année comptable).
 */

const startOfMonth = (y, m) => new Date(y, m - 1, 1);

/**
 * Calcule la plage [start, end] basée sur le preset et la config fiscale.
 * @param {string} preset
 * @param {{fiscal_year_start_month?:number, fiscal_year_start_day?:number}} appConfig
 * @param {Date} now
 * @returns {{start:Date, end:Date}}
 */
export const computeRange = (preset, appConfig = {}, now = new Date()) => {
  const fiscalMonth = appConfig?.fiscal_year_start_month || 1;
  const fiscalDay = appConfig?.fiscal_year_start_day || 1;

  switch (preset) {
    case "3months": {
      const start = startOfMonth(now.getFullYear(), now.getMonth() - 1); // 3 mois incl. courant
      return { start: new Date(now.getFullYear(), now.getMonth() - 2, 1), end: now };
    }
    case "12months":
      return { start: startOfMonth(now.getFullYear() - 1, now.getMonth() + 1), end: now };
    case "current_quarter": {
      const q = Math.floor(now.getMonth() / 3); // 0..3
      return {
        start: startOfMonth(now.getFullYear(), q * 3 + 1),
        end: now,
      };
    }
    case "current_civil_year":
      return { start: new Date(now.getFullYear(), 0, 1), end: now };
    case "current_fiscal_year": {
      // Si on est avant le mois/jour de début, on est dans l'exercice précédent
      const candidateStart = new Date(now.getFullYear(), fiscalMonth - 1, fiscalDay);
      let start = candidateStart;
      if (now < candidateStart) {
        start = new Date(now.getFullYear() - 1, fiscalMonth - 1, fiscalDay);
      }
      return { start, end: now };
    }
    case "3years":
      return { start: new Date(now.getFullYear() - 3, now.getMonth(), 1), end: now };
    case "all":
      return { start: new Date(2015, 0, 1), end: now };
    default:
      return { start: new Date(now.getFullYear() - 1, now.getMonth() + 1, 1), end: now };
  }
};

/**
 * Convertit une Date en ISO string sans heure (00:00 UTC).
 */
export const toIso = (d) => (d instanceof Date ? d.toISOString() : null);

/**
 * Format "Jan 2026" depuis une clé "2026-01".
 */
export const formatMonthKey = (period) => {
  if (!period) return "";
  const MONTHS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"];
  if (period.includes("-")) {
    const [y, m] = period.split("-");
    return `${MONTHS[parseInt(m, 10) - 1]} ${y}`;
  }
  return period;
};
